export default function (adminLocation) {
  window.location.assign(`/admin/${adminLocation}`);
}
